
import axios from 'axios'
import { REACT_APP_API } from 'cfgCommon/config';

export async function getPossibleActions(statusId) {
  const result = await axios
    .get(
      `${REACT_APP_API}/possible-actions?status_id=${statusId}`
    )

  return result?.data
}
